import React from 'react';
import {
  Button,
  Card,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Alert,
} from 'reactstrap';
import AccountInfoSummary from 'views/sast2/components/AccountInfoSummary';
import { getHostLabel, HostType } from 'views/sast2/helper';

const ReConnectAccountModal = ({ hostType, account, onConnect, onClose }) => {
  const toggleModal = () => {
    onClose();
  };

  return (
    <Card>
      <Modal isOpen={true} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>
          Re-Connect Your {getHostLabel(hostType)} Account
        </ModalHeader>
        <ModalBody>
          <div>
            <AccountInfoSummary
              props={account}
              description={'Account is disconnected.'}
              mode={'normal'}
            />
          </div>
          <p>
            Please review the account information above. If you have access to
            the respective {getHostLabel(account.host_type)} account then
            proceed to re-authorize and re-connect this account.
          </p>
          {hostType === HostType.Azure && (
            <Alert color="secondary" className="mb-3">
              <p className="mb-1">
                <strong>Important:</strong> Connecting a new Azure DevOps
                account requires admin consent. If you’re not an admin, you’ll
                be prompted to request approval from your organization’s
                administrator. You can return here once the request is approved
                to complete the connection.
              </p>
              <p className="mb-0">
                <strong>For administrators:</strong> On the OAuth permissions
                screen, select
                <em> “Consent on behalf of your organization” </em> to grant
                access for other non admin users in your tenant to connect their
                accounts.
              </p>
            </Alert>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => onConnect()}>
            Re-Connect Account
          </Button>{' '}
          <Button color="secondary" onClick={toggleModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </Card>
  );
};

export default ReConnectAccountModal;
